<ng-template #content let-modal>
    <div class="ml-2">
        <div class="modal-header">
            <h4>Assign Parent to Student</h4>
        </div>
    <label for="email">Email</label>
        <input class="form-control col-md-8" autocomplete="dont_d0_it_brows3r_i_mEAN_IT"
            name="email" placeholder="Enter email" [ngbTypeahead]="searchExistingParents"
            (selectItem)="existingParentSelected($event)" [resultFormatter]="resultFormatter"
            [inputFormatter]="inputFormatter" [(ngModel)]="data.Email"/>
        <div *ngIf="existingAccount()" class="user-type">
            existing account
        </div>
        <div *ngIf="!existingAccount()" >
            <label for="name">Full Name</label>
            <input class="form-control col-md-8" [(ngModel)]="data.Name">
        </div>
    </div>
    <div class="d-flex" *ngIf="!existingAccount()">
        <div class="col-md-5">
            <label for="sendEmail">Send Welcome Email</label>
            <input class="form-control col-md-8" name="sendEmail" type="checkbox" [(ngModel)]="sendWelcomeEmail"
                    (change)="sendWelcomeEmailChanged()">
        </div>
        <div class="col-md-7" *ngIf="!sendWelcomeEmail">
            <label for="password">Set Password</label>
            <input class="form-control col-md-8" name="password" [(ngModel)]="data.Password"
                    placeholder="password">
        </div>
    </div>
    <div class="modal-footer" style="border: none">
        <button *ngIf="!isWaiting" type="button" class="btn btn-outline-secondary btn-lg"
            (click)="modal.dismiss('Cross click')">Cancel</button>
        <button *ngIf="!isWaiting" [disabled]="!isInputValid()" type="button" class="btn btn-primary btn-lg"
            (click)="modalSubmitted()">{{submitButtonText}}</button>
        <app-loading-spinner *ngIf="isWaiting"></app-loading-spinner>
    </div>
</ng-template>

<button class="btn btn-primary" (click)="openForNew()" style="width: 15vw;" type="button">Assign Parent</button>